import { Button, CircularProgress, useTheme } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import React, { useState } from "react";

import { DocumentAddButton } from "../../../components/fields/DocumentsField/AddButton";
import { DropPaper } from "../../../components/fields/DocumentsField/DropPaper";
import { FileInfo } from "../../../components/fields/DocumentsField/SimpleFileInfo";
import { InfoBox } from "./InfoBox";

interface FileUploaderAction {
  label: string;
  onClick: (file: File) => Promise<void>;
  color?: "primary" | "secondary" | "default";
  variant?: "contained" | "outlined" | "text";
}

interface FileUploaderProps {
  title: string;
  accept: string;
  actions: FileUploaderAction[];
  isLoading: boolean;
  style?: React.CSSProperties;
  chooseFileButtonText?: string;
}

export const FileUploader: React.FC<FileUploaderProps> = ({
  title,
  accept,
  actions,
  isLoading,
  style,
  chooseFileButtonText,
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const theme = useTheme();

  const handleActionClick = async (action: FileUploaderAction) => {
    if (!selectedFile) return;

    try {
      await action.onClick(selectedFile);
      setSelectedFile(null); // Clear file after successful upload
    } catch (error) {
      // Error handling is done in the parent's onClick handler
    }
  };

  return (
    <DropPaper
      processDocument={setSelectedFile}
      uploading={isLoading}
      elevation={0}
      // TODO To change Paper background: use another MuiThemeProvider or not use paper.  
      style={{ backgroundColor: "transparent"}}
    >
      <InfoBox title={title} style={style}>
        <div style={{ marginBottom: 12 }}>
          <DocumentAddButton
            uploadFile={setSelectedFile}
            uploading={isLoading}
            acceptTypes={accept}
            disabled={isLoading}
            onBeforeUpload={undefined}
            label={chooseFileButtonText}
            variant="outlined"
            color="secondary"
            fullWidth
          />
          {selectedFile && (
            <div style={{ marginTop: 8 }}>
              <FileInfo file={selectedFile} setFile={setSelectedFile} />
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          {actions.map((action, index) => (
            <Button
              key={index}
              variant={action.variant || "contained"}
              color={action.color || "primary"}
              onClick={() => handleActionClick(action)}
              disabled={!selectedFile || isLoading}
              startIcon={
                <CloudUploadIcon />
              }
              fullWidth
            >
              {action.label}
            </Button>
          ))}
        </div>
      </InfoBox>
    </DropPaper>
  );
};
